import {
  chatWithGPT4
} from "../chatGpt.js";
import { getCachedScript } from "../scriptCache.js";

function kanyeWest(){

  getCachedScript();

  window.jsx.evalScript("run(postGpt());", function (result) {
    chatWithGPT4(result.split("\r\n"))
      .then((string) =>
      window.jsx.evalScript("run(getGpt(" + JSON.stringify(string) + "));")
      )
      .catch((error) => alert(error));
  });
}

export default kanyeWest;
